import React from 'react';
// Bootstrap
import {  Dropdown, Pagination } from 'react-bootstrap';

// React Router
import { withRouter } from 'react-router-dom'

import './pagination.scss'

const InspirePagination = (props) => {

  // Generate startPage/endPage
  let startPage = props.currentPage - 1;
  let endPage = props.currentPage + 3;
  if (props.currentPage - 1 < 1) {
    startPage = 1; endPage = props.totalPage>5?5:props.totalPage;
  }
  if (props.currentPage + 3 > props.totalPage) {
    startPage = props.totalPage - 4; endPage = props.totalPage;
    if(startPage < 1) startPage = 1;
  }
  let items = []
  for (let page = startPage; page <= endPage; page++) {
    items.push(
      <Pagination.Item key={page}      
        active={page === props.currentPage}
        onClick={(e) => props.onClick(page)}>
        {page}
      </Pagination.Item>,
    );
  }

  const previousPage = () => {
    if( props.currentPage - 1 < 0){
      //console.log("reached min page")
      return
    } 
    props.onClick(props.currentPage-1)
  }
  const nextPage = () => {
    if( props.currentPage + 1 > props.totalPage){
      //console.log("reached max page")
      return
    } 
    props.onClick(props.currentPage+1)
  }

  return (
    <div className="w-100 text-right">
      <div style={{ display: 'inline-block', paddingTop: '1em' }}>
        <Pagination bsPrefix="inspire-pagination">
          <Pagination.First disabled={props.currentPage === 1} 
                  onClick={(e) => previousPage()} />
          {items}
          <Pagination.Last disabled={props.currentPage === props.totalPage} 
                  onClick={(e) => nextPage()} />
        </Pagination>
      </div>
    </div>
  )
}


export default withRouter(InspirePagination);
